module.exports = __webpack_public_path__ + "img/invoice.efd20f7c.svg";